import { db } from './config';
import {
  collection,
  addDoc,
  getDocs,
  doc,
  updateDoc,
  deleteDoc
} from 'firebase/firestore';

const COLLECTION_NAME = 'faqs';

const sortByOrder = (a, b) => {
  const orderA = a.order !== undefined ? a.order : 999;
  const orderB = b.order !== undefined ? b.order : 999;
  if (orderA === orderB) {
    return (a.question || '').localeCompare(b.question || '');
  }
  return orderA - orderB;
};

// Get all FAQs (admin)
export const getFaqs = async () => {
  try {
    const snapshot = await getDocs(collection(db, COLLECTION_NAME));
    const faqs = [];
    snapshot.forEach((docSnap) => {
      faqs.push({ id: docSnap.id, ...docSnap.data() });
    });
    return faqs.sort(sortByOrder);
  } catch (error) {
    console.error('Error getting FAQs:', error);
    return [];
  }
};

// Get only active FAQs (public homepage)
export const getActiveFaqs = async () => {
  const all = await getFaqs();
  return all.filter((f) => f.active !== false);
};

// Add a new FAQ. Appends to the end of the order.
export const addFaq = async (faqData) => {
  try {
    const existing = await getFaqs();
    const maxOrder = existing.reduce((max, f) => Math.max(max, f.order || 0), 0);

    const newFaq = {
      question: faqData.question || '',
      answer: faqData.answer || '',
      answerColor: faqData.answerColor || 'black',
      active: faqData.active !== undefined ? faqData.active : true,
      order: maxOrder + 1,
      createdAt: new Date().toISOString()
    };

    const docRef = await addDoc(collection(db, COLLECTION_NAME), newFaq);
    return { id: docRef.id, ...newFaq };
  } catch (error) {
    console.error('Error adding FAQ:', error);
    throw error;
  }
};

// Update a FAQ
export const updateFaq = async (id, faqData) => {
  try {
    const { id: _ignore, ...clean } = faqData;
    const updated = {
      ...clean,
      updatedAt: new Date().toISOString()
    };
    await updateDoc(doc(db, COLLECTION_NAME, id), updated);
    return { id, ...updated };
  } catch (error) {
    console.error('Error updating FAQ:', error);
    throw error;
  }
};

// Delete a FAQ
export const deleteFaq = async (id) => {
  try {
    await deleteDoc(doc(db, COLLECTION_NAME, id));
    return id;
  } catch (error) {
    console.error('Error deleting FAQ:', error);
    throw error;
  }
};
